import {Component, Input} from '@angular/core';


@Component({
    selector: 'app-fz152',
    imports: [],
    templateUrl: './fz152.component.html',
    styleUrl: './fz152.component.scss'
})
export class Fz152Component {
  @Input() type: 'agent' | 'client' | 'self' = 'agent';
}
